import React from 'react'
import { footerLinks } from '../constants'
import { QRCode, fullDarkLogo, fullLightLogo } from '../utils'
export default function Footer({theme, setTheme}){
  return (
    <footer id='footer' className="py-0 pb-5 sm:py-10 px-10 px-5">
      <div className="screen-max-width">
        <div className="flex flex-col justify-between pt-5 pb-0 sm:flex-row sm:pb-16">
          <div className="logo my-auto sm:block hidden">
            <img src={theme==='dark'?fullLightLogo:fullDarkLogo} width={240} alt="" />
            {/* <p className='mt-4 ml-2 text-lg text-light-black dark:text-white-dark'>致力让世界更智能！</p> */}
          </div>
          <div className='py-5 sm:pb-0'>
            <div>
              <div className='font-bold text-lg text-light-black dark:text-white-dark'>
                联系我们
              </div>
              <div className="bg-[#D8D8D8] my-1 h-[1px] w-full" />
              <div className='text-sm text-gray-light dark:text-white'>
                <p className='my-2 font-thin' style={{fontFamily: 'Pang'}}>深圳市铁越电气有限公司</p>
                <p className='my-2 font-thin' style={{fontFamily: 'Pang'}}>深圳市龙岗区天安数码城4栋B座8层801、804</p>
                <p className='my-2 font-thin' style={{fontFamily: 'Pang'}}>电话：15338716307</p>
                <p className='my-2 font-thin' style={{fontFamily: 'Pang'}}>邮箱：teamway@machinivis.com</p>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div className='font-bold text-lg text-light-black dark:text-white-dark'>
                商务洽谈（微信）
              </div>
              <div className="bg-[#D8D8D8] my-1 h-[1px] w-full mb-4 sm:mb-0" />
              <div>
                <img src={QRCode} className='w-64 mx-auto sm:w-36 sm:mt-2' alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#D8D8D8] my-5 h-[1px] w-full" />

        <div className="flex md:flex-row flex-col md:items-center justify-between ">
          <p className="dark:text-white-dark text-gray-light text-xs" style={{fontFamily: 'Pang'}}>Copright @ 2025 深圳市铁越电气有限公司. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

// export default Footer